<div class="p-gutter container">
  <div class="card p-3 ">
    <h4 class="text-center">{{ mode === 'review' ? 'Review SAQ Examination' : 'Mark SAQ Examination' }} for
      {{examination.examinationName}}</h4>
    <hr>

    <div class="row" *ngIf="candidatesQuestionsData && candidatesQuestionsData.length > 0">
      <div *ngIf="mode === 'mark'">
        <small class="text-muted   fw-bold">No. of candidates assigned: {{candidatesQuestionsData.length}} | </small> 
        <small class="text-muted  fw-bold">Marked: {{totalMarkedCandidates}} | </small>
        <small class="text-muted  fw-bold">Unmarked: {{totalUnMarkedCandidates}} </small>

      </div>
      <div *ngIf="mode === 'review' ">
        <small class="text-muted  fw-bold">Total No. Candidates: {{candidatesQuestionsData[0].candidateCount}} | </small>
        <small class="text-muted  fw-bold">No. assigned: {{candidatesQuestionsData.length}} | </small>
        <small class="text-muted  fw-bold">Reviewed: {{totalCandidatesReviewed}} | </small>
        <small class="text-muted  fw-bold">Pending: {{totalCandidatesPending}} </small>

      </div>
      <div class="col-md-3 candidatesdiv" style="max-height: 80vh; overflow-y: auto;">
        <div *ngFor="let cand of candidatesQuestionsData">
          <div class="justify-content-between">
            <button class="p-3 btn  mb-1 canlist" [id]="cand.examNo"
              [ngClass]="cand.marked?  cand.reviewed? 'btn-reviewed':'btn-marked' 
              :'btn-unmarked'"
              (click)="loadCandidateQuestions(cand)">{{cand.examNo}}
              <div class="d-inline ml-1" *ngIf="cand.marked">
                <button>
                  <span *ngIf="cand.marked && !cand.reviewed">Marked </span>
                  <span *ngIf="cand.reviewed && cand.marked ">Reviewed </span>
                  <span class=""><mat-icon class="mat-icon-button icon-sm " svgIcon="mat:check_circle" title="Marked"
                      style="font-size: x-small;"></mat-icon></span>

                </button>
                <small *ngIf="mode=='review' && cand.examiner && cand.marked" class="d-block">Marked By: {{cand.examiner}}</small>
                <small *ngIf="cand.reviewer && cand.reviewed" class="d-block">Reviewed By: {{cand.reviewer}}</small>

              </div>
            </button>
          </div>

        </div>
      </div>
      <div class="col-md-9" style="max-height: 80vh; overflow-y: auto;" #origin>
        <div class="p-gutter" *ngIf="selectedCandidateQuestion">
          <div *ngIf="mode != 'review' && selectedCandidateQuestion?.marked" class="alert alert-warning mt-1">
            <b class="text-muted">
              This essay has already been graded and is no longer eligible for re-evaluation.
            </b>
          </div>
          <div class="headerdiv" id="scrollToTop">
            <h4>Candidate Number: {{selectedCandidateQuestion.examNo}}</h4>
            <h5>Examination Name: {{examination.examinationName}}</h5>
            <h6> Duration: {{examination.duration}} mins Examination Status: {{selectedCandidateQuestion.examStatus}}
            </h6>
            <hr>
          </div>
          <div class="card p-3 mb-2"
            *ngFor="let question of selectedCandidateQuestion.essayQuestionModels; let i = index">
            <h5>Question {{i+1}}</h5>
            <h5 class="" [innerHTML]="question.question"></h5>
            <div class="form-control border-box" [innerHTML]="question.candidateAnswer"></div>
            <div class="mt-3">
              <p class="text-muted">Possible Answers: {{question.possibleAnswers}}</p>
            </div>
            <div class="d-flex mt-3">
              <label class="form-label mr-2 mt-2">Marked:</label>
              <ng-select class="form-select mr-2" [(ngModel)]="question.answerStatusString"
                [ngModelOptions]="{ standalone: true }" disabled="true">
                <ng-option value="NotMarked">Not Marked</ng-option>
                <ng-option value="Correct">Correct</ng-option>
                <ng-option value="Incorrect">Incorrect</ng-option>
              </ng-select>

              <ng-container *ngIf="mode !== 'review'">
                <button class="btn btn-success mr-2" (click)="markCorrect(question,i,selectedCandidateQuestion.examNo)"
                  [disabled]="question.answerStatusString=='Correct'" [disabled]="selectedCandidateQuestion.marked">Mark
                  Correct</button>
                <button class="btn btn-warning" (click)="markIncorrect(question,i,selectedCandidateQuestion.examNo)"
                  [disabled]="question.answerStatusString=='Incorrect'"
                  [disabled]="selectedCandidateQuestion.marked">Mark Incorrect</button>
              </ng-container>

              <button *ngIf="mode === 'review'" class="btn btn-primary ml-auto"
                (click)="openAdjustScoreModal(question,i,selectedCandidateQuestion.examNo)">Adjust Score</button>
            </div>
          </div>
          <div class="mt-3">
            <h5>Total Score: {{calculateTotalScore(selectedCandidateQuestion)}}</h5>
          </div>
          <div class="d-flex justify-content-center mt-3">

            <div class="mb-3 mr-0 col-lg-7">
              <button class="form-control bg-success text-white" type="button" (click)="markCandidate(origin)"
                *ngIf="mode !== 'review' && !selectedCandidateQuestion?.marked">
                Submit Assessment
              </button>

              <button class="form-control bg-success text-white" type="button" (click)="markCandidate(origin)"
                *ngIf="mode === 'review' && !selectedCandidateQuestion?.reviewed">
                Submit Review
              </button>
            </div>
          </div>
          <div class="d-flex justify-content-between mt-3">

            <button class="btn btn-primary" (click)="previousCandidate()" [disabled]="!hasPreviousCandidate()">Previous
              Candidate</button>
            <button class="btn btn-primary" (click)="nextCandidate()" [disabled]="!hasNextCandidate()">Next
              Candidate</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade " id="confirmSubmitModal" tabindex="-1" role="dialog"
    aria-labelledby="confirmSubmitModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="confirmSubmitModalLabel">Confirm Submission</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span (click)="closeModal()">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          Are you sure you want to submit marks for this candidate? Submitting means essay scores cannot be updated
          afterward.
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeModal()">Cancel</button>
          <button type="button" class="btn btn-primary" (click)="confirmSubmit()">Yes, Submit</button>
        </div>
      </div>
    </div>
  </div>

</div>